import logo from './logo.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Puffery Marketing 
        </p>
        <a
          className="App-link"
          href="https://www.youtube.com/@pufferymarketing"
        >
          YouTube Channel
        </a>
      </header>
    </div>
  );
}

export default App;
